import { Injectable } from '@angular/core';
import { AngularNavigationService } from './angular-navigation.service';

// import { OutletManagementService } from './outlet-management.service';

/**
 * Migration Initialization Service
 *
 * Centralizes the initialization of all migration-related services for the UI-Router to Angular Router transition.
 * This service should be called once during application bootstrap to set up all Angular Router lifecycle hooks.
 *
 * Key Responsibilities:
 * - Initialize Angular Navigation Service (replaces UI-Router onTransitionSuccess)
 * - Set up any other migration-related services
 * - Ensure proper service initialization order
 * - Provide a single point of initialization for the migration
 *
 * Usage:
 * Call initialize() from AppModule or main component constructor
 *
 * NOTE: OutletManagementService DISABLED - auxiliary outlets were causing complex URLs
 * Now using static header/footer/sideRail components in app.component.html instead
 */
@Injectable({
  providedIn: 'root'
})
export class MigrationInitializationService {

  private initialized = false;

  constructor(
    private angularNavigationService: AngularNavigationService
    // DISABLED: OutletManagementService causes auxiliary outlet URLs like (header:unified-header)
    // private outletManagementService: OutletManagementService
  ) {}

  /**
   * Initialize all migration services
   * This should be called once during application bootstrap
   */
  initialize(): void {
    if (this.initialized) {
      console.warn('MigrationInitializationService: Already initialized, skipping duplicate initialization');
      return;
    }

    try {
      // Initialize Angular Navigation Service (replaces UI-Router onTransitionSuccess)
      this.angularNavigationService.initialize();

      // Initialize Outlet Management Service (handles auxiliary outlets automatically)
      // DISABLED: OutletManagementService was causing complex auxiliary outlet URLs
      // Now using static header/footer/sideRail components instead

      this.initialized = true;

    } catch (error) {
      console.error('MigrationInitializationService: Error during initialization', error);
      throw error;
    }
  }

  /**
   * Check if migration services have been initialized
   */
  isInitialized(): boolean {
    return this.initialized;
  }
}
